const hideSnackbar = () => {
	return {
		type: 'HIDE_SNACKBAR',
	};
};

const showSnackbar = () => {
	return {
		type: 'SHOW_SNACKBAR',
	};
};

const setSnackbar = (msg) => {
	return {
		type: 'SET_SNACKBAR',
		value: msg,
	};
};

const setArticles = (articles, totalItems, statKey, page) => {
	return {
		type: 'SET_ARTICLES',
		value: articles,
		totalItems: totalItems,
		statKey: statKey,
		page: page,
	};
};

const setProducts = (products, totalItems, statKey, page) => {
	return {
		type: 'SET_PRODUCTS',
		value: products,
		totalItems: totalItems,
		statKey: statKey,
		page: page,
	};
};

const setSearchEdit = (edit) => {
	return {
		type: 'SET_SEARCH_EDIT',
		value: edit,
	};
};

export {
	hideSnackbar,
	showSnackbar,
	setSnackbar,
	setArticles,
	setProducts,
	setSearchEdit,
};
